import axios from "axios";
import { loginReducerApi } from "../constants/apiConstants";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import decryptContent from './decryptContent';
import { useNavigate } from "react-router-dom";
import { decryptPayload, encryptPayload } from "./encrypt";

const client = axios.create({});

async function getToken() {
  let newAccessToken = "";
  await axios
    .get(loginReducerApi.generateToken)
    .then(
      (result) => {
        const decryptedResponse = decryptContent(result.data);
        const payload = JSON.parse(
          window.atob(decryptedResponse.response?.split(".")[1])
        );
        const expiration = new Date(payload.exp * 1000);
        newAccessToken = decryptedResponse.response;
        Cookies.set("token", decryptedResponse.response, {
          expires: expiration,
          path: "",
        });
      },
      (error) => {}
    );
  return newAccessToken;
}

async function getNewAccessToken(token) {
  let newAccessToken = "";
  const encryptedPayload = encryptPayload({refreshToken: token});
  await axios
    .post(loginReducerApi.refreshToken, {data: encryptedPayload})
    .then(
      (result) => {
        const decryptedString = decryptPayload(result?.data?.data);
        newAccessToken = decryptedString.accessToken;
        Cookies.set("authToken",decryptedString.accessToken,{expires: 365, path: ""});
      },
      (error) => {}
    );
  return newAccessToken;
}

client.interceptors.request.use(
  async (config) => {
    let token = Cookies.get("token");
    let authUserToken = Cookies.get("authToken");
    let refreshUserToken = Cookies.get("refreshToken");

    let currentDate = new Date();
    let decodedToken = "";
    let decodedAuthToken = "";
    let decodedRefreshToken = "";

    try {
      if (token) {
        decodedToken = jwtDecode(token);
      }
    } catch {
      decodedToken = "";
    }

    try {
      if (authUserToken) {
        decodedAuthToken = jwtDecode(authUserToken);
      }
    } catch {
      decodedAuthToken = "";
    }

    try {
      if (refreshUserToken) {
        decodedRefreshToken = jwtDecode(refreshUserToken);
      }
    } catch {
      decodedRefreshToken = "";
    }

    if(decodedAuthToken && decodedAuthToken.exp * 1000 - 10000 < currentDate.getTime()){
      // Get new access token if it expires
      if(decodedRefreshToken && decodedRefreshToken.exp * 1000 - 10000 > currentDate.getTime()){
        authUserToken = await getNewAccessToken(refreshUserToken);
      } else {
        // Logout if refresh token expires
        Cookies.set("loginStatus", false, { path: "", expires: 365 });
        Cookies.remove("authToken");
        Cookies.remove("refreshToken");
        let navigate = useNavigate();
        navigate("/signin");
      }
    }

    if (!token) {
      token = await getToken();
    } else if (
      decodedToken &&
      decodedToken.exp * 1000 - 10000 < currentDate.getTime()
    ) {
      token = await getToken();
    }
    config.headers = {
      Authorization: authUserToken,
      Accept: "application/json",
      token: token,
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const request = function (options) {
  const onSuccess = function (response) {
    return response.data;
  };

  const onError = function (error) {
    return Promise.reject(error.response || error.message);
  };

  return client(options).then(onSuccess).catch(onError);
};

export default request;
